import { KatalComponent } from '../../shared/base';

/**
 * @component {kat-spinner} KatalSpinner Used to indicate a long running operation is being performed on the UI
 * @status Production
 * @theme flo
 */
export class KatalSpinner extends KatalComponent {
  static get observedAttributes() {
    return ['variant', 'size'];
  }

  constructor() {
    super(KatalSpinner.observedAttributes);
  }

  connectedCallback() {
    super.connectedCallback();
    this.render();
  }

  /**
   * @param {enum} variant The type of spinner to show
   * @enum {value} default The default spinner
   * @enum {value} inverted Inverted colors used for dark themes
   */
  get variant() {
    return this.getAttribute('variant') || 'default';
  }

  set variant(value) {
    this.setAttribute('variant', value);
  }

  /**
   * @param {enum} size The size of the spinner to display. Defaults to large
   * @enum {value} small A smaller size spinner icon
   * @enum {value} large A larger size spinner icon.  This is the default size
   */
  get size() {
    return this.getAttribute('size') || 'large';
  }

  set size(value) {
    this.setAttribute('size', value);
  }

  render() {
    this.innerHTML = '<div></div><div></div><div></div><div></div>';
  }

  // Respond to attribute changes.
  attributeChangedCallback() {
    this.render();
  }
}

KatalComponent.register('kat-spinner', KatalSpinner);
